import { BuilderConfig } from '../../../types/Builder';
import B2BGoodFor, { B2BGoodForProps } from './b2b-good-for';

export const B2BGoodForBuilderConfig = {
    name: 'B2B Good For V2',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'color',
        },
        {
            name: 'textColor',
            type: 'color',
        },
        {
            name: 'content',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                },
                {
                    name: 'imageMobile',
                    type: 'file',
                },
                {
                    name: 'title',
                    type: 'text',
                },
                {
                    name: 'buttonText',
                    type: 'text',
                },
                {
                    name: 'buttonLink',
                    type: 'url',
                },
                {
                    name: 'item',
                    type: 'list',
                    subFields: [
                        {
                            name: 'content',
                            type: 'string',
                        },
                    ],
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<B2BGoodForProps> = {
    component: B2BGoodFor,
    config: B2BGoodForBuilderConfig,
};

export default builderConfig;
